import React, { useEffect } from 'react';

interface HotjarSnippetProps {
    /** The Hotjar customer/account ID */
    hotjarId: string;
    /** Hotjar snippet version - Defaults to 6 */
    snippetVersion?: number;
}

/**
 * Component that renders the Hotjar tracking code snippet.
 */
function HotjarSnippet({ hotjarId, snippetVersion = 6 }: HotjarSnippetProps): React.ReactElement<HotjarSnippetProps> {
    useEffect(() => {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://static.hotjar.com/c/hotjar-${hotjarId}.js?sv=${snippetVersion}`;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [hotjarId, snippetVersion]);

    return <></>; // This component doesn't render any UI
}

export default HotjarSnippet;
